/**
 * Shared CSSStyleSheet for web components using shadow DOM.
 *
 * Instead of each shadow root loading /dist/style.css via a <link> element
 * (which duplicates the full stylesheet in memory per instance), this module
 * fetches the CSS once and exposes a single CSSStyleSheet that all shadow
 * roots share via adoptedStyleSheets.
 */

let _sheetPromise = null;

/**
 * Returns a promise that resolves to a shared CSSStyleSheet containing
 * the site styles. The sheet is fetched and constructed once, then cached.
 *
 * Usage in connectedCallback:
 *   import { getSharedStyleSheet } from './sharedStyleSheet.js';
 *
 *   async connectedCallback() {
 *       const sheet = await getSharedStyleSheet();
 *       this.shadowRoot.adoptedStyleSheets = [sheet];
 *   }
 */
export function getSharedStyleSheet() {
    if (!_sheetPromise) {
        _sheetPromise = (async () => {
            const res = await fetch('/dist/style.css');
            const css = await res.text();
            const sheet = new CSSStyleSheet();
            await sheet.replace(css);
            return sheet;
        })();
    }
    return _sheetPromise;
}
